import React from 'react';
import '../style/PrivacyTerms.css';

const PrivacyPolicyEn = () => {
    return (
        <div className="static-page">
            <h1 className="align-center">Privacy Policy</h1>
            <p className="align-center">Last updated: 30.09.24</p>

            <h3>1. Introduction</h3>
            <p>
                1. Welcome to the digital services of [Not Alone] (hereinafter referred to as "the Company" or "we"), which includes our application [available at www.not-alone.app] (hereinafter: "the Digital Services"). We respect the privacy of our users who use the Digital Services (hereinafter: "the User(s)" or "you") and are committed to protecting the personal information collected about you. We are committed to informing our users about how we collect and use the information provided by you during and after the use of the Digital Services, as well as outlining the Company's policy and its commitment to user privacy.
            </p>
            <p>
                1.1. The purpose of this Privacy Policy (hereinafter: "the Privacy Policy") is to respect and protect user privacy and explain the Company's practices regarding user privacy in the Digital Services and how the Company uses the information provided by users or collected during the use of the Digital Services.
            </p>
            <p>
                1.2. This document is written in the masculine form for convenience, but refers to both genders equally.
            </p>

            <h3>2. Consent</h3>
            <p>
                2.1. Your use of the Digital Services will be considered as your consent to all the terms, conditions, and notices related to the Digital Services. Providing personal data through the Digital Services indicates your consent for the Company to use this data in accordance with this Privacy Policy.
            </p>
            <p>
                2.2. When using the Digital Services, information is collected from you, as detailed below – for the purpose of receiving the requested services. In certain cases, you may be required to provide personal information relevant to the requested service. By providing such details, you confirm that the personal information you provided is accurate and complete, and that you have done so voluntarily, without any legal obligation to do so unless explicitly stated otherwise. Some of the data collected is non-identifiable and is not stored with your personal details.
            </p>
            <p>
                2.3. Waiver of Claims: By using the website, you confirm that you have no claims, demands, or lawsuits against the Company or its representatives regarding the platform, its limitations, or any misalignments, if any.
            </p>

            <h3>3. Collection and Storage of Personal Information</h3>
            <p>
                3.1. Information you provide to us: Some of the Digital Services offered by the Company require user authentication by entering personal details such as full name, photo, and email address. You may also use the Digital Services without entering personal information, but note that submitting identification and contact details is required to access certain services. Users who do not wish to provide identification or contact details, or whose provided details do not match the official records, will not be able to use the online service and should contact the Company to access the service by other means.
            </p>
            <p>
                3.2. Registration for services: If personal details are required when registering for the Digital Services, the Company will request only the information necessary for providing the service.
            </p>
            <p>
                3.3. Automatically Collected Information: When you use the Digital Services, the Company collects information sent by your mobile device or other device used to access the services. This information includes, but is not limited to: IP address, device identifier, device type, geographic location, connection details, network data for mobile devices, page view statistics, site traffic data, referral URL, advertisement data, and other standard web log details. Additionally, anonymous information may be collected via Cookies and web beacons (see "Cookie Policy" below).
            </p>
            <p>
                3.4. Contacting Us: You can contact us in several ways, including by using a contact form where you will need to provide personal information such as contact details and email address. In this case, you choose what information you want to share with us in your message.
            </p>
            <p>
                3.5. We are not responsible for any damage, of any kind, caused to you or anyone on your behalf, directly or indirectly, due to browsing the website.
            </p>

            <h3>4. Use of Information</h3>
            <p>
                The use of the information detailed above will be done in accordance with applicable law, agreements, and this Privacy Policy, for the following purposes:
            </p>
            <p>
                1. To allow users to use the various Digital Services;
            </p>
            <p>
                2. For providing services by the Company;
            </p>
            <p>
                3. To process statistical data through the collection and analysis of anonymous, statistical, or aggregate information by the Company or by third parties, to improve and enrich the services and content and enhance the user experience;
            </p>
            <p>
                4. To identify, prevent, or address fraud, security issues, or technical problems;
            </p>
            <p>
                5. To protect third-party rights, including intellectual property, privacy, and defamation;
            </p>
            <p>
                6. To respond to inquiries from users and manage them;
            </p>
            <p>
                7. Direct marketing and communication with users;
            </p>
            <p>
                8. For the security of the Digital Services;
            </p>
            <p>
                9. To share information with third parties as outlined in this Privacy Policy;
            </p>
            <p>
                10. The information you provide will be stored in the Company's databases and may be used for operational purposes or statistical analysis.
            </p>

            <h3>5. Databases</h3>
            <p>
                5.1. The data collected will be stored in our databases and are our responsibility.
            </p>
            <p>
                5.2. The use of the information will be carried out in accordance with the purposes outlined, and in compliance with the relevant laws, including privacy protection laws.
            </p>
            <p>
                5.3. We are committed to adhering to the provisions of the Privacy Protection Law, 1981 (hereinafter: "Privacy Protection Law") and the Privacy Protection Regulations, including the 2017 "Information Security Regulations."
            </p>

            <h3>6. Transfer of Information to Third Parties</h3>
            <p>
                6.1. For providing services: The Company may transfer personal information to affiliated companies and/or third parties, provided it is necessary for operational purposes, payment processing, user account management, communication, statistical analysis, and direct marketing, including sending text messages or emails related to the Company's services.
            </p>
            <p>
                6.2. The Company will not transfer identifiable personal information to third parties except in the following cases:
            </p>
            <div className='small-padding'>
                <p>
                    6.2.1. At the user's request and/or with explicit consent.
                </p>
                <p>
                    6.2.2. In case the user violates the terms of use or the privacy policy, or in cases where fraudulent activities or other illegal actions are detected.
                </p>
                <p>
                    6.2.3. Pursuant to a court order requiring the Company to provide information to third parties.
                </p>
                <p>
                    6.2.4. In the event of any legal dispute or claim between the user and the Company.
                </p>
                <p>
                    6.2.5. When the Company believes it is necessary to prevent or minimize damage to property or personal injury.
                </p>
                <p>
                    6.2.6. If the Company transfers its rights and obligations to a third party, provided that the third party accepts this Privacy Policy.
                </p>
                <p>
                    6.2.7. With third-party service providers who assist in providing services, such as cloud computing, communication, maintenance, and similar services.
                </p>
                <p>
                    6.2.8. Sharing anonymous information for research, statistics, or service improvement.
                </p>
            </div>

            <h3>7. Data Security</h3>
            <p>
                7.1. The Company implements various organizational, infrastructural, and technical measures to protect your personal data. However, as with any computerized information system, the Company cannot guarantee absolute protection against breaches or attempts to access your data without authorization.
            </p>
            <p>
                7.2. You agree not to engage in any unauthorized actions to infiltrate or disrupt the Company's computer systems or networks.
            </p>

            <h3>8. Consent for Marketing and Direct Communication</h3>
            <p>
                8.1. We may send direct marketing materials, such as newsletters or promotional messages, based on your membership in specific groups or actions taken on the site.
            </p>
            <p>
                8.2. You may opt out of these communications at any time by contacting us or using the unsubscribe options provided in the communication.
            </p>

            <h3>9. Cookie Policy</h3>
            <p>
                The Digital Services use cookies to track users' behavior on the platform, and provide personalized services and marketing. You may manage your cookie preferences in your browser settings.
            </p>

            <h3>10. User Rights</h3>
            <p>
                10.1. You have the right to request access to and correction of your personal data at any time, and to request deletion if the information is no longer necessary for the service.
            </p>
            <p>
                10.2. To exercise these rights or for further information, please contact us via the provided communication channels.
            </p>
            
            <h3>11. Changes to this Policy</h3>
            <p>
                11.1. The Company may update this Privacy Policy from time to time, and any such updates will be reflected on this page. We recommend reviewing this page periodically to stay informed about how we protect your data.
            </p>

            <h3>12. Minors</h3>
            <p>
                12.1. The Digital Services are not intended for users under the age of 18. The Company does not knowingly collect personal information from individuals under 18. If it is discovered that a minor has provided personal data, the Company will delete that information immediately.
            </p>

            <h3>13. Contact Us</h3>
            <p>
                13.1. For any questions or concerns regarding this Privacy Policy, or if you wish to exercise your rights regarding your personal data, please contact us at [contact details].
            </p>
        </div>
    );
}

export default PrivacyPolicyEn;
